// extracted by mini-css-extract-plugin
export default {"Prefix":"yYv5QQF5","Suffix":"EdUbuR2m","Control":"ahn3lq7v"};